module.exports = __webpack_public_path__ + "zvetseni-prsou_45_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_45_after.jpg
// module id = 1339
// module chunks = 0